<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-program-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 v-if="isMain">PROGRAMS</h4>
      <h4 v-else-if="isEdit">EDIT PROGRAM</h4>
      <h4 v-else-if="isPage">ADD NEW PROGRAM PAGE</h4>
       <h4 v-else>ADD NEW PROGRAM</h4>

      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :key="$vs.rtl"
    >
    <div id="program-content">

    </div>
      <image-library-sidebar
      @setImg="setImg"
      :isSidebarActive="ImageViewSidebar"
      @closeSidebar="toggleImageSidebar"
    />
     <add-program-page
      :pageData="newProgram"
      :isSidebarActive="isPageCreate"
      @setProgramTemplate="setProgramTemplate"
    />
    <div id="program_data" ref="program_data" class="hidden">
      <section class="program-section pink-bg sb-program section-dltable" data-gjs-type="dltable">
        <div class="auto-container nondltable" data-gjs-removable="false" data-gjs-propagate='["editable","removable","badgable","hoverable","highlightable","copyable","resizable","draggable","dropable"]'>
            <div class="sec-title text-center">
                  <span class="title text-light">{{ProgramData.data.title}}</span>
                  <h2 class="text-light">{{ProgramData.data.subtitle}}</h2>
            </div>
            <div class="row">
              <div class="owl-theme services-carousel owl-carousel">
                  <div v-for="(service,sindex) in ProgramData.data.services" :key="sindex" class="service text-center col-sm-12 wow fadeInUp">
                    <a :href=service.link>
                          <img :src=service.image alt="" class="img-responsive" >
                          <h4>{{service.name}}</h4>
                      </a>
                    <p>{{service.details}}</p>
                    <div class="program-info d-flex">
                         <div class="program-box" v-for="(program_box,pindex) in service.program_box" :key="pindex">
                          <h6>{{program_box.name}}</h6>
                          <h6 class="text-color2">{{program_box.value}}</h6>
                        </div>
                    </div>
                    <div class="program-readmore-info">
                          <a class="btn btn-style-three theme-btn" :href=service.button.lin>{{service.button.name}}</a>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </section>
    </div>

     <div class="p-3" v-if="proData">
      <span v-if="isMain">
      <div>
        <vs-input label-placeholder="Title" v-model="proData.data.title" class="w-full mb-base"></vs-input>
        <vs-input label-placeholder="Subtitle" v-model="proData.data.subtitle" class="w-full mb-base"></vs-input>
      </div>
          <div class="w-full cursor-pointer p-2 font-bold text-primary flex justify-between">
           <small class="text-center">ALL PROGRAMS</small>
           <span class="flex-inline">
             <vs-dropdown vs-trigger-click class="cursor-pointer">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <vs-dropdown-menu>
                  <vs-dropdown-item  @click="isNew=true;isMain=false;isEdit=false,isPage=false">
                    <span class="flex items-center mt-2">
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <small  class="font-semibold">Program</small>
                    </span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
           </span>
         </div>
              <ul class="vs-list mb-base">
              <li
                v-for="(service,index) in proData.data.services" :key="index"
                class="w-full cursor-pointer ml-2 p-2"
                 @mouseover="mouseOver(index,'')"
                @mouseleave="mouseLeave(index,'')"
                :ref="'li-with-'+index+'-'"
              >
                <span class="flex items-center">
                  <span>{{ service.name }}</span>
                  <span class="ml-auto mr-12 hidden" :ref="'div-with-'+index+'-'">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" />
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="editPro(index)">
                          <span class="flex items-center mt-2">
                            <feather-icon
                              icon="EditIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small  class="font-semibold">Edit</small>
                          </span>
                          </vs-dropdown-item>
                          <vs-dropdown-item @click="deletePro(index,service.page)">
                          <span class="flex items-center mt-2 text-danger" >
                            <feather-icon
                              icon="TrashIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small class="font-semibold">Delete</small>
                          </span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gotoPage(index,service.page)">
                          <span class="flex items-center mt-2 " >
                            <feather-icon
                              icon="PlusIcon"
                              svgClasses="h-4 w-4"
                              class="mr-2"
                            />
                            <small class="font-semibold">Goto Page</small>
                          </span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </span>
                </span>
              </li>
            </ul>   
      </span> 
      <span v-if="isNew">
        <vs-input  label-placeholder="Name"  v-model="newProgram.name" class="w-full mb-base"></vs-input>
        <vs-input  label-placeholder="Link"   v-model="newProgram.link" class="w-full mb-base hidden"></vs-input>
        <vs-textarea label="Details" v-model="newProgram.details" class="w-full"></vs-textarea>
        <label class="vs-select--label w-full">Age</label>
        <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Label" v-model="newProgram.program_box[0].name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="Value" v-model="newProgram.program_box[0].value"></vs-input>
        </vs-col>
      </vs-row>
      <label class="vs-select--label w-full">Seats</label>
      <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Label"  v-model="newProgram.program_box[1].name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="Value"  v-model="newProgram.program_box[1].value" ></vs-input>
        </vs-col>
      </vs-row>
       <label class="vs-select--label w-full">Price</label>
        <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Label"  v-model="newProgram.program_box[2].name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="Value" v-model="newProgram.program_box[2].value"></vs-input>
        </vs-col>
      </vs-row>
       <!-- <label class="vs-select--label w-full">Button</label> -->
        <!-- <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Text" v-model="newProgram.button.name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="Link" v-model="newProgram.button.link"></vs-input>
        </vs-col>
      </vs-row> -->
      <vs-row class="mb-base">
        <vs-col v-if="newProgram.image" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <img :src="newProgram.image" alt="" width="150px" height="150px">
        </vs-col>
        <vs-col  vs-w="6">
          <vs-button color="primary" @click.native="toggleImageSidebar(true)"
                  >Upload Image</vs-button>
        </vs-col>
      </vs-row>
      </span>
       <span v-if="isEdit">
        <vs-input  label-placeholder="Name" v-model="editProgram.name" class="w-full mb-base"></vs-input>
        <!-- <vs-input  label-placeholder="Link" v-model="editProgram.link" class="w-full mb-base"></vs-input> -->
        <vs-textarea label="Details" v-model="editProgram.details" class="w-full"></vs-textarea>
        <label class="vs-select--label w-full">Boxes</label>
        <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Age" v-model="editProgram.program_box[0].name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="1 - 2 Years" v-model="editProgram.program_box[0].value"></vs-input>
        </vs-col>
      </vs-row>
      <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Seats"  v-model="editProgram.program_box[1].name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="10"  v-model="editProgram.program_box[1].value" ></vs-input>
        </vs-col>
      </vs-row>
        <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Price"  v-model="editProgram.program_box[2].name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="198$" v-model="editProgram.program_box[2].value"></vs-input>
        </vs-col>
      </vs-row>
       <label class="vs-select--label w-full">Button</label>
        <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
         <vs-input placeholder="Text" v-model="editProgram.button.name"></vs-input>
        </vs-col>
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
           <vs-input placeholder="Link" v-model="editProgram.button.link"></vs-input>
        </vs-col>
      </vs-row>
            <vs-row class="mb-base">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <img v-if="editProgram.image" :src="editProgram.image" alt="" width="150px" height="150px">
        </vs-col>
        <vs-col  vs-w="6">
          <vs-button color="primary" @click.native="toggleImageSidebar(true)"
                  >Browse</vs-button>
        </vs-col>
      </vs-row>
      </span>
        <span v-if="isPage">
           <vs-input  label-placeholder="Heading" v-model="newPage.heading" class="w-full mb-base"></vs-input>
            <vs-input  label-placeholder="Subheading" v-model="newPage.subheading" class="w-full mb-base"></vs-input>
            <vs-textarea label="Details" v-model="newPage.details" class="w-full"></vs-textarea>
            <span class="flex justify-between">
            <label for="">Buttons</label>
             <vs-button size="small" @click="addBtn">Add New</vs-button>
            </span>
             <vs-row v-for="(btn,btnindex) in newPage.buttons" :key="btnindex">
             <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
             <vs-input label-placeholder="Text" v-model="btn.text" ></vs-input>
             </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="5">
              <vs-input label-placeholder="Link" v-model="btn.link"></vs-input>
             </vs-col>
             <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <vs-button size="small" color="danger" @click="removeBtn(btnindex)" class="mt-5">-</vs-button>
             </vs-col>
             </vs-row>
            <span class="flex justify-between mt-5">
            <label for="">Paragraph</label>
             <vs-button size="small" @click="addParagraph">Add New</vs-button>
            </span>
            <span v-for="(paragraph,pindex) in newPage.paragraphs" :key="pindex">
              <span class="flex  justify-between mt-5">
               <label for="">Paragraph {{pindex+1}}</label>
               <vs-button size="small" @click="removeParagraph(pindex)">-</vs-button>
              </span>
              
              
              <vs-input v-model="paragraph.heading" label-placeholder="Paragraph Heading"  class="w-full mb-base"></vs-input>
              <vs-textarea v-model="paragraph.details" label="Details" class="w-full"></vs-textarea>
            </span>
            
           
      </span>
     </div>
    </component>
     <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isMain">
      <vs-button class="mr-6" @click.native="createProgram" :disabled="!isProgramValid">Create</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isEdit">
         <vs-button class="mr-6" @click.native="editSaveProgram">Save</vs-button>      
         <vs-button type="border" color="danger" @click="isMain=true;isNew=false;isEdit=false;isPage=false">Cancel</vs-button>
    </div>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isNew">
      <vs-button class="mr-6" @click.native="createNewProgram">Create</vs-button>         
      <vs-button type="border" color="danger" @click="isMain=true;isNew=false;isEdit=false;isPage=false">Cancel</vs-button>
    </div>
    <div class="flex flex-wrap items-center p-6" slot="footer" v-if="isPage">
      <vs-button class="mr-6" @click.native="createProgramPage">Create</vs-button>         
      <vs-button type="border" color="danger" @click="isMain=true;isNew=false;isEdit=false;isPage=false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ImageLibrarySidebar from "./ImageLibrarySidebar.vue";
import addProgramPage from "./addProgramPage.vue";
import { CREATE_NEW_PROGRAM_TEMPLATE ,SAVE_MENU_DRAFT ,GET_PROGRAM_TEMP ,SAVE_PROGRAM_SECTION} from "@/graphql";
import {
  program_temp,
} from "./ProgramTemplate";
// function programTemplate(){
// return `<section class="program-section pink-bg" data-gjs-type="programdata">
//    <div class="auto-container">
//       <div class="sec-title text-center">
//             <span class="title text-light">${ProgramData.data.title}</span>
//             <h2 class="text-light">${ProgramData.data.subtitle}</h2>
//       </div>
//       <div class="row">
//          <div class="owl-theme services-carousel owl-carousel">
//           ${ProgramData.data.services.map(service => 
//             `<div class="service text-center col-sm-12 wow fadeInUp">
//                <a href=${service.link}>
//                     <img src=${service.image} alt="" class="img-responsive" >
//                     <h4>${service.name}</h4>
//                 </a>
//                <p>${service.details}</p>
//                <div class="program-info d-flex">
//                 ${service.program_box.map(program_box =>
//                    `<div class="program-box">
//                     <h6>${program_box.name}</h6>
//                     <h6 class="text-color2">${program_box.value}</h6>
//                    </div>`
//                 )}
//                </div>
//                <div class="program-readmore-info">
//                     <a class="btn btn-style-three theme-btn" href=${service.button.link}>${service.button.name}</a>
//                </div>
//             </div>`
//             )}
//          </div>
//       </div>
//    </div>
// </section>`
// }
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: String,
    },
    currentPage:{
       type: Object,
    }
  },
  components: {
    VuePerfectScrollbar,
     "image-library-sidebar": ImageLibrarySidebar,
      "add-program-page": addProgramPage,
  },
  data() {
    return {
      ProgramData:{
        data : {
          title : "Advantage Early Learning Center" ,
          subtitle :"Childcare Programs",
          services:[
            {
              page:"infants",
              link:"/curriculum/infants.phtml",
              image:'https://dev3.barqsol.com/basic/images/infants.jpg',
              name:'Infants',
              details:`Advantage's Infant Program provides personal care and attention for your child as they begin developing trust for the world.`,
              program_box:[
                {
                  name:"Age",
                  value:"6 Wk - 12 Mo"
                },
                {
                  name:"Seats",
                  value:"10"
                },
                {
                    name:"Price",
                    value:"$215"
                }
              ],
              button : {
                name:"Read More",
                link:"/curriculum/infants.phtml"
              }
            },
            {
              page:"toddlers",
              link:"/curriculum/toddlers.phtml",
              image:'https://dev3.barqsol.com/basic/images/program-2.jpg',
              name:'Toddlers',
              details:`Our Toddlers Program is designed with the best age-appropriate activities to help children feel secure in their developing independence.`,
              program_box:[
                {
                  name:"Age",
                  value:"1 - 2 Years"
                },
                {
                  name:"Seats",
                  value:"12"
                },
                {
                    name:"Price",
                    value:"$198"
                }
              ],
              button : {
                name:"Read More",
                link:"/curriculum/toddlers.phtml"
              }
            },
            {
              page:"preschool",
              link:"/curriculum/preschool.phtml",
              image:'https://dev3.barqsol.com/basic/images/program-3.jpg',
              name:'Preschool',
              details:`The Preschool program is an early childhood program that helps set your child up for a successful
                     and confident school career.`,
              program_box:[
                {
                  name:"Age",
                  value:"3 - 5 Years"
                },
                {
                  name:"Seats",
                  value:"16"
                },
                {
                    name:"Price",
                    value:"$179"
                }
              ],
              button : {
                name:"Read More",
                link:"/curriculum/preschool.phtml"
              }
            },
              {
              page:"school",
              link:"/curriculum/school.phtml",
              image:'https://dev3.barqsol.com/basic/images/school.jpg',
              name:'School Age',
              details:`Our school age program provides new challenges, close friendships, and increasing responsibilities for our oldest learners.`,
              program_box:[
                {
                  name:"Age",
                  value:"5 - 12 Years"
                },
                {
                  name:"Seats",
                  value:"25"
                },
                {
                    name:"Price",
                    value:"$181"
                }
              ],
              button : {
                name:"Read More",
                link:"/curriculum/preschool.phtml"
              }
            },
            {
              page:"summer",
              link:"/curriculum/summer.phtml",
              image:'https://dev3.barqsol.com/basic/images/summer.jpg',
              name:'Summer Camp',
              details:`Drama classes, fun weekly field trips, and craft classes are just a few of the activities your child will enjoy at Advantage over the summer.`,
              program_box:[
                {
                  name:"Age",
                  value:"5 - 12 Years"
                },
                {
                  name:"Seats",
                  value:"20"
                },
                {
                    name:"Price",
                    value:"$280"
                }
              ],
              button : {
                name:"Read More",
                link:"/curriculum/summer.phtml"
              }
            }
          ]
        }
},
      ImageViewSidebar: false,
      proDom:null,
      finalProgram:null,
      isMain:true,
      isNew:false,
      isEdit:false,
      isPage:false,
      editProgram:null,
      current:null,
      isPageCreate:false,
      newProgram: {
              link:"",
              image:'',
              name:'',
              details:'',
              program_box:[
                {
                  name:"",
                  value:""
                },
                {
                  name:"",
                  value:""
                },
                {
                    name:"",
                    value:""
                }
              ],
              button : {
                name:"Read More",
                link:"/curriculum/infants.phtml"
              }
            },
      newPage:{
            "name":"",
            "heading":"",
            "subheading":"",
             "details":"",
             "buttons":[],
             "paragraphs":[]  
      } , 
      activeLoading : false    ,
      ProgramMainTemplate:program_temp,
      proData:null,
      ProgramMenu:[] ,
      menuData:[],
      ProgramMenuIndex:null,
    }
  },
  watch: {
    isNew(val){
      if(!val){
        this.newProgram = {
              page:"",
              link:"",
              image:'',
              name:'',
              details:'',
              program_box:[
                {
                  name:"",
                  value:""
                },
                {
                  name:"",
                  value:""
                },
                {
                    name:"",
                    value:""
                }
              ],
              button : {
                name:"Read More",
                link:""
              }
            }
      }
    },
    isEdit(val){
      if(!val){
         this.current = null
      }
    },
    proData: {
      handler(val, oldVal) {
         this.ProgramData = val

      },
      deep: true,
    },
    isSidebarActive(val) {
      if (!val) return;
       else{
           var menus = {...this.$store.getters.getBuilderMenu}
           menus = menus.menu
           this.menuData=menus
           console.log(menus)
           for (let index = 0; index < menus.length; index++) {
             const menu = menus[index];
             if(menu.type==='dropdown' && menu.id==='programs'){
                 this.ProgramMenu=menu.menu
                 this.ProgramMenuIndex=index
             }
             
           }
            console.log(this.ProgramMenu)
            console.log(this.ProgramMenuIndex)
            this.proData=this.ProgramData
        // if(localStorage.getItem('program_list')){
        //    this.proData=JSON.parse(localStorage.getItem('program_list'))
           
        //   //  localStorage.setItem('menu-data',this.menuData)
        // }
        // else{
        //     this.proData=this.ProgramData
        // }
        this.isMain=true
        this.isNew=false
        this.isEdit=false
         this.isPage=false
         this.isPageCreate=false
          this.proDom=this.data
            this.initValues();
    }
           }


  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isProgramValid() {
      return (
        !this.errors.any() 
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
     getPageName(name){
      const arr = [];
      for (let i = 0; i < this.menuData.length; i++) {
        const element = this.menuData[i];
         arr.push(element.page)
         if(element.page==='dropdown'){
         for (let j = 0; j < element.menu.length; j++) {
           const subMenu = element.menu[j];
             arr.push(subMenu.page)
           }
         }
      }
      name = name.toLowerCase().replaceAll(" ", "_")
      var input = name;
      if(arr.indexOf(input) < 0){
        var new_page = input
      }
      else{
      var regex = new RegExp(input);
      var matched = arr.filter((x) => x.match(regex))
      var highest = 0
      matched.forEach(m => {
          var s = m.split('-')[1]
          if(s>highest){
              highest = s
          }
      });
          var new_index = parseInt(highest)+1
          var new_page = input+'-'+new_index
      }
      return new_page;
    },
    SaveMenuData(){
        this.menuData[this.ProgramMenuIndex].menu=this.ProgramMenu
        var menu = {"menu":this.menuData} 
        console.log(menu) 
        this.$store.dispatch('setBuilderMenu',menu)
        this.SaveMenuFile(JSON.stringify(menu))
        },
       SaveMenuFile(data){
       const site = this.currentPage.siteName;
       this.$apollo
          .mutate({
            mutation: SAVE_MENU_DRAFT,
            variables: {
              site: site,
              menu:data
            },
          })
          .then((response) => {

          })
          .catch((error) => {
            console.log(error);
          });
    },    
    setProgramTemplate(val){
      if(this.newProgram.id){
        this.loader();
        this.$apollo
         .mutate({
          mutation: CREATE_NEW_PROGRAM_TEMPLATE,
          variables: {
            page:'/programs/'+this.newProgram.id,
            site:this.currentPage.siteName,
            html:val
          },
        })
        .then((response) => {
          if(response.data.createNewProgramTemplate.status==='Success'){
            this.activeLoading = false;
            this.$vs.loading.close();
            this.SaveMenuData();
            this.$nextTick(() => {
                    this.createProgram()
            })
            
          }
        })
        .catch((error) => {
          console.log(error);
          this.activeLoading = false;
          this.$vs.loading.close();
        });
         this.isPageCreate=false
     }
      else{
        if(this.newProgram.name){
        var page = this.getPageName(this.newProgram.name);
        this.newProgram.page = page
        var new_id =  new Date().valueOf()
        var path = "/programs/"
        var link =  path+new_id
        var newPage =
                {
                  id: new_id,
                  type: "page",
                  title: this.newProgram.name,
                  page:  page,
                  path:  path,
                  show:  true
                }
      this.ProgramMenu.push(newPage)        
      this.loader();
      this.$apollo
         .mutate({
          mutation: CREATE_NEW_PROGRAM_TEMPLATE,
          variables: {
            page:link,
            site:this.currentPage.siteName,
            html:val
          },
        })
        .then((response) => {
          if(response.data.createNewProgramTemplate.status==='Success'){
            this.newProgram.link=link
            this.newProgram.page=page
            this.newProgram.id=new_id
            this.newProgram.button.link=link
            this.proData.data.services.push(this.newProgram);
            this.activeLoading = false;
            this.$vs.loading.close();
            this.SaveMenuData();
            this.$nextTick(() => {
                    this.createProgram()
            })
            
          }
          else{
           alert("Name Already exist")
           this.activeLoading = false;
          this.$vs.loading.close();
          }
        })
        .catch((error) => {
          console.log(error);
          this.activeLoading = false;
          this.$vs.loading.close();
        });
         this.isPageCreate=false
     }
      }

    },
    createProgramPage(){
       this.isPageCreate=true
    },
    removeBtn(i){
     this.newPage.buttons.splice(i, 1) 
    },
    removeParagraph(i){
      this.newPage.paragraphs.splice(i, 1) 
    },
    addBtn(){
      this.newPage.buttons.push({"text":"","link":""})
    },
     addParagraph(){
      this.newPage.paragraphs.push({"heading":"","details":""})
    },
    gotoPage(index,name){
      this.newPage.name=this.proData.data.services[index].name
      this.current=index
      // this.isPage=true
      // this.isEdit=false
      // this.isMain=false
      // this.isNew=false
      var site={
        'sitePage':name,
        'siteName':this.currentPage.siteName
      }
      console.log(site)
      this.$emit("setPage", site);
    },
    editSaveProgram(){
      var current = this.current
      this.proData.data.services[current] = this.editProgram
      // this.isPageCreate=true
      this.createProgram()
    },
    editPro(index){
      this.current = index
      this.editProgram = this.proData.data.services[index]
      // this.newProgram =  this.proData.data.services[index]
      this.isEdit=true
      this.isMain=false
      this.isNew=false
      this.isPage=false
    },
    deletePro(i,p){
      this.proData.data.services.splice(i, 1);
      for (var j = this.ProgramMenu.length - 1; j >= 0; j--) {
        if (this.ProgramMenu[j].page === p) {
             this.ProgramMenu.splice(j, 1);
        }
        }
      this.SaveMenuData()  
    },
    setImg(val){
     if(this.isNew){
       this.newProgram.image=val
     } 
     if(this.isEdit){
       this.editProgram.image=val
     }
    },
    toggleImageSidebar(val = false) {
      this.ImageViewSidebar = val;
    }, 
   createNewProgram(){
     this.isPageCreate=true
    //  if(this.newProgram.name){
    //   this.loader();
    //   this.$apollo
    //      .mutate({
    //       mutation: CREATE_NEW_PROGRAM_TEMPLATE,
    //       variables: {
    //         page:this.newProgram.name+'.html',
    //         site:this.currentPage.siteName,
    //         html:this.ProgramMainTemplate
    //       },
    //     })
    //     .then((response) => {
    //       if(response.data.createNewProgramTemplate.status==='Success'){
    //         this.proData.data.services.push(this.newProgram);
    //         this.activeLoading = false;
    //         this.$vs.loading.close();
    //         this.createProgram()
    //         var site={
    //        'sitePage':this.newProgram.name+'.html',
    //        'siteName':this.currentPage.siteName
    //      }
    //      console.log(this.$route.params.siteName)
    //      this.$emit("setPage", site);
    //       }
    //       else{
    //        alert("Name Already exist")
    //        this.activeLoading = false;
    //       this.$vs.loading.close();
    //       }
    //       // this.renderPage(response.data.getPageContent.template);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.activeLoading = false;
    //       this.$vs.loading.close();
    //     });
    //  }
    
    //   this.proData.data.services.push(this.newProgram);
    //    console.log(this.proData.data.services.length)
    // this.createProgram()
  },
  createProgram(){
      this.$emit('creatProgrm',this.$refs.program_data.innerHTML)

      localStorage.setItem('program_list',JSON.stringify(this.proData))
      this.SaveProgramSection(this.$refs.program_data.innerHTML)
      this.isEdit=false
      this.isMain=true
      this.isNew=false
      this.isPage=false
  },
     loader() {
      this.activeLoading = true;
      this.$vs.loading({
        type: "sound",
      });
    },
initValues (){

},   
 mouseOver: function (parent,node) {
           var referenceIcon=`div-with-${parent}-${node}`
           var referenceLi=`li-with-${parent}-${node}`
           const icon_element = this.$refs[referenceIcon]
           const li_element = this.$refs[referenceLi]
           icon_element[0].classList.remove('hidden');
           li_element[0].classList.add('menuHover');
          //  li_element[0].classList.add('text-white');
    },
    mouseLeave: function (parent,node) {
           var referenceIcon=`div-with-${parent}-${node}`
           var referenceLi=`li-with-${parent}-${node}`
           const icon_element = this.$refs[referenceIcon]
           const li_element = this.$refs[referenceLi]
            icon_element[0].classList.add('hidden');
            li_element[0].classList.remove('menuHover');    
            // li_element[0].classList.remove('text-white');
    },
 SaveProgramSection(html){
       var data = JSON.stringify(this.proData)
       const site = this.$route.params.siteName;
       this.$apollo
          .mutate({
            mutation: SAVE_PROGRAM_SECTION,
            variables: {
               site: site,
               data:data,
               html:html,
            },
          })
          .then((response) => {
             console.log(response)
          })
          .catch((error) => {
            console.log(error);
          });
 },   
  },
  created(){
        this.$apollo
        .mutate({
          mutation: GET_PROGRAM_TEMP,
           variables: {
            site: this.$route.params.siteName,
          },
        })
        .then((response) => {
          var data = JSON.parse(response.data.getProgramTemp.data)
          this.ProgramData =  data
          console.log(this.ProgramData)
         
          //  this.menu_temp = response.data.getProgramTemp.data
          //  var menu=JSON.parse(response.data.getProgramTemp.pro_data)
          //  this.$store.dispatch('setBuilderMenu', menu)
          //  localStorage.setItem('web-data-url',response.data.getMenuTemp.url)

          //  var menu_data=this.$store.getters.getBuilderMenu
          //  this.menuData=JSON.parse(menu_data).menu
          //  localStorage.setItem('menu-data',response.data.getMenuTemp.menu_data)
          //  console.log(this.menuData)
        })
        .catch((error) => {
          console.log(error);
        });
  }
}
</script>

<style lang="scss" scoped>
.add-program-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 350px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";
button.btn-async {
  background: rgba(var(--vs-warning), 0.15);
}

button.btn-delete {
  background: rgba(var(--vs-danger), 0.15);
}
.con-vs-dropdown--menu {
  z-index: 999999;
}
.menuHover{
  border-left: #5C52C0 4px solid;
  background: #F8F8F8;
}

</style>
